'use client'

import classnames from 'classnames'
import styles from './DayInTheLifeVideo.module.scss'
import Icon from '@/components/Icon/Icon'
import HeaderWithCtas from '@/components/HeaderWithCtas/HeaderWithCtas'
import AnimateContainer from '@/components/AnimateContainer/AnimateContainer'
import VideoLoop from '@/components/VideoLoop/VideoLoop'
import { CSSProperties, useRef, useState } from 'react'

const DayInTheLifeVideo = ({
  className,
  eyebrow,
  headingContent,
  textColor,
  verticalAlign,
  overlayOpacity = 40,
  videoLoopDesktop,
  videoLoopMobile,
  sectionIndex,
}: SanityDayInTheLifeVideo) => {
  const videoLoopRef = useRef<VideoLoopImperativeHandle>(null)
  const [isMuted, setIsMuted] = useState(true)

  const handleToggleMute = () => {
    const videoEl = videoLoopRef.current?.getElement() as HTMLVideoElement | null
    if (!videoEl) return
    const newMuted = !isMuted
    videoEl.muted = newMuted
    setIsMuted(newMuted)
  }

  if (
    !headingContent ||
    !videoLoopDesktop?.asset?.url ||
    !videoLoopMobile?.asset?.url
  ) {
    return null
  }

  return (
    <div
      className={classnames(styles.DayInTheLifeVideo, className)}
      style={
        {
          '--overlay-opacity': overlayOpacity / 100,
        } as CSSProperties
      }
      data-text-color={textColor}
      data-align-items={headingContent.alignItems}
      data-vertical-align={verticalAlign}
    >
      <div className={styles.inner}>
        <AnimateContainer
          animationType="fadeInUp"
          className={classnames(styles.content, {
            [styles.centered]: headingContent.alignItems === 'center',
          })}
          setImmediate={sectionIndex === 0}
        >
          {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
          <HeaderWithCtas {...headingContent} />
        </AnimateContainer>
      </div>

      <div className={styles.overlay} />

      <div className={styles.mediaContainer}>
        <VideoLoop
          ref={videoLoopRef}
          desktopLoop={videoLoopDesktop}
          mobileLoop={videoLoopMobile}
          desktopSizeMb={3}
          mobileSizeMb={0.75}
          className={styles.video}
        />
      </div>

      <button
        className={styles.audioToggle}
        onClick={handleToggleMute}
        aria-label={isMuted ? 'Unmute video' : 'Mute video'}
      >
        <Icon
          name={isMuted ? 'speakerOff' : 'speakerOn'}
          className={styles.audioToggleIcon}
        />
      </button>
    </div>
  )
}

DayInTheLifeVideo.displayName = 'DayInTheLifeVideo'

export default DayInTheLifeVideo
